import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class downloadExplanationReportService {

    constructor(private http: HttpClient) { }

    downloadFile(filePath: string) {
        return this.http.get(filePath, { responseType: 'blob' });
    }
}